import React from 'react';
import Button from 'components/Button';
import PropTypes from 'prop-types';
import { P } from 'components/Typography';
import { ButtonsWrapper, StyledModal } from './styled';

const CaliforniaSpecialNotice = ({ onClose, isOpen, onYes, onNo }) => {
  return (
    <StyledModal
      header="CALIFORNIA RESIDENTS SPECIAL NOTICE"
      isOpen={isOpen}
      onClose={onClose}
    >
      <P>
        THE INSURANCE POLICY THAT YOU ARE APPLYING TO PURCHASE IS BEING ISSUED BY AN
        INSURER THAT IS NOT LICENSED BY THE STATE OF CALIFORNIA. THESE COMPANIES ARE
        CALLED "NONADMITTED" OR "SURPLUS LINE" INSURERS.
      </P>

      <P>
        THE INSURER IS NOT SUBJECT TO THE FINANCIAL SOLVENCY REGULATION AND ENFORCEMENT
        THAT APPLY TO CALIFORNIA LICENSED INSURERS.
      </P>

      <P>
        THE INSURER DOES NOT PARTICIPATE IN ANY OF THE INSURANCE GUARANTEE FUNDS CREATED
        BY CALIFORNIA LAW. THEREFORE, THESE FUNDS WILL NOT PAY YOUR CLAIMS OR PROTECT YOUR
        ASSETS IF THE INSURER BECOMES INSOLVENT AND IS UNABLE TO MAKE PAYMENTS AS
        PROMISED.
      </P>

      <P>
        THE INSURER SHOULD BE LICENSED EITHER AS A FOREIGN INSURER IN ANOTHER STATE IN THE
        UNITED STATES OR AS A NON-UNITED STATES (ALIEN) INSURER. YOU SHOULD ASK QUESTIONS
        OF YOUR INSURANCE AGENT, BROKER, OR “SURPLUS LINE” BROKER OR CONTACT THE
        CALIFORNIA DEPARTMENT OF INSURANCE AT THE FOLLOWING TOLL-FREE TELEPHONE NUMBER
        1-800-927-4357. ASK WHETHER OR NOT THE INSURER IS LICENSED AS A FOREIGN OR
        NON-UNITED STATES (ALIEN) INSURER AND FOR ADDITIONAL INFORMATION ABOUT THE
        INSURER. YOU MAY ALSO CONTACT THE NAIC’S INTERNET WEB SITE AT WWW.NAIC.ORG.
      </P>

      <P>
        FOREIGN INSURERS SHOULD BE LICENSED BY A STATE IN THE UNITED STATES AND YOU MAY
        CONTACT THAT STATE’S DEPARTMENT OF INSURANCE TO OBTAIN MORE INFORMATION ABOUT THAT
        INSURER.
      </P>

      <P>
        FOR NON-UNITED STATES (ALIEN) INSURERS, THE INSURER SHOULD BE LICENSED BY A
        COUNTRY OUTSIDE OF THE UNITED STATES AND SHOULD BE ON THE NAIC’S INTERNATIONAL
        INSURERS DEPARTMENT (IID) LISTING OF APPROVED NONADMITTED NON-UNITED STATES
        INSURERS. ASK YOUR AGENT, BROKER, OR “SURPLUS LINE” BROKER TO OBTAIN MORE
        INFORMATION ABOUT THAT INSURER.
      </P>

      <P>
        CALIFORNIA MAINTAINS A LIST OF APPROVED SURPLUS LINE INSURERS. ASK YOUR AGENT OR
        BROKER IF THE INSURER IS ON THAT LIST, OR VIEW THAT LIST AT THE INTERNET WEB SITE
        OF THE CALIFORNIA DEPARTMENT OF INSURANCE: www.insurance.ca.gov.
      </P>

      <P>
        IF YOU, AS THE APPLICANT, REQUIRED THAT THE INSURANCE POLICY YOU HAVE PURCHASED BE
        BOUND IMMEDIATELY, EITHER BECAUSE EXISTING COVERAGE WAS GOING TO LAPSE WITHIN TWO
        BUSINESS DAYS OR BECAUSE YOU WERE REQUIRED TO HAVE COVERAGE WITHIN TWO BUSINESS
        DAYS, AND YOU DID NOT RECEIVE THIS DISCLOSURE FORM AND A REQUEST FOR YOUR
        SIGNATURE UNTIL AFTER COVERAGE BECAME EFFECTIVE, YOU HAVE THE RIGHT TO CANCEL THIS
        POLICY WITHIN FIVE DAYS OF RECEIVING THIS DISCLOSURE. IF YOU CANCEL COVERAGE, THE
        PREMIUM WILL BE PRORATED AND ANY BROKER’S FEE CHARGED FOR THIS INSURANCE WILL BE
        RETURNED TO YOU.
      </P>

      <P>
        07/11
        <br />
        LSW1146D
      </P>

      <P>
        If you have read and agreed to the terms of this notice and wish to continue,
        please click the continue button. Otherwise, please click cancel to abort the
        application process.
      </P>

      <ButtonsWrapper>
        <Button
          onClick={() => {
            onNo();
            onClose();
          }}
          variant="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onYes();
            onClose();
          }}
        >
          Continue
        </Button>
      </ButtonsWrapper>
    </StyledModal>
  );
};

CaliforniaSpecialNotice.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  onYes: PropTypes.func,
  onNo: PropTypes.func
};

export default CaliforniaSpecialNotice;
